import type { InfoBarPrefs } from '@omnia/shared';

/** Height of the thin top bar in px; the desk starts below it while the bar is docked. */
export const BAR_HEIGHT = 40;

/** Vertical space the bar takes away from the desk; zero when it sits behind the windows. */
export function dockedHeight(prefs: Pick<InfoBarPrefs, 'position'>): number {
  return prefs.position === 'above' ? BAR_HEIGHT : 0;
}
